import { Stack, Tooltip, Typography, TypographyVariant } from "@mui/material";
import { InfoIcon } from "src/foundations/icons";

import { ReactElement } from "react";

export interface TooltipDetails {
    /**
     * Assigned to the tooltip icon.
     * @deprecated since 7.10.10. To be removed.
     */
    tooltipId?: string;
    text?: string;
    /** Assigned to the tooltip text. */
    "data-testid"?: string;
    /** Assigned to the tooltip text. */
    id?: string;
}

export type SenecTooltipProps = {
    tooltip: TooltipDetails | undefined;
    iconColor?: string;
    variant?: TypographyVariant;
    /** Assigned to the tooltip icon. */
    "data-testid"?: string;
    /** Assigned to the tooltip icon. */
    id?: string;
};

/**
 * @deprecated please use SenecInfoTooltip instead
 */
export const SenecTooltip = ({ tooltip, iconColor, variant = "body1", ...otherProps }: SenecTooltipProps): ReactElement => {
    return (
        <>
            {tooltip && tooltip.text && tooltip.text !== "" && (
                <Tooltip
                    key={tooltip.tooltipId + "-tooltip"}
                    title={
                        <Typography
                            variant={variant}
                            key={tooltip.tooltipId + "-text"}
                            data-testid={tooltip["data-testid"]}
                            id={tooltip.id}
                        >
                            {tooltip.text}
                        </Typography>
                    }
                    disableInteractive
                    enterTouchDelay={0}
                    leaveTouchDelay={1}
                    enterNextDelay={100}
                >
                    <Stack
                        direction={"row"}
                        alignItems={"center"}
                        color={iconColor || "senecSecondary.neutralGray70"}
                        key={tooltip.tooltipId + "-span"}
                        data-testid={otherProps["data-testid"] ?? tooltip.tooltipId}
                        id={otherProps.id}
                    >
                        <Typography
                            sx={{
                                lineHeight: "0",
                            }}
                        >
                            <InfoIcon
                                key={tooltip.tooltipId + "-icon"}
                                data-testid="InfoIcon"
                                sx={{
                                    "&:hover": { cursor: "pointer" },
                                }}
                            />
                        </Typography>
                    </Stack>
                </Tooltip>
            )}
        </>
    );
};

/**
 * @deprecated use SenecTooltip instead
 */
export const FppTooltip = SenecTooltip;
